import * as Styled from "./style";
import { G_ServicePlan, type Maybe } from "~/lib/graphql";
import { useAuth } from "~/provider/auth";

type Props = {
  price: number;
  salePrice?: Maybe<number>;
  isMultiPrice: boolean;
};

export const LimitedPremiumDetailPriceText = (props: Props) => {
  const { price, salePrice, isMultiPrice } = props;
  const { servicePlan } = useAuth();
  const rangeSymbol = isMultiPrice ? "〜" : "";
  const priceText = `${price.toLocaleString()}円`;
  const salePriceText = `${salePrice?.toLocaleString()}円${rangeSymbol}`;
  const isPremium = servicePlan === G_ServicePlan.Premium;

  return (
    <>
      <Styled.SpanPriceWrapper>
        <Styled.SpanPriceLabel>通常価格</Styled.SpanPriceLabel>
        <Styled.SpanPrice isStrikethrough={isPremium}>{priceText}</Styled.SpanPrice>
      </Styled.SpanPriceWrapper>
      {salePrice && (
        <Styled.SpanSalePriceWrapper>
          <Styled.SpanSalePriceLabel>特別価格</Styled.SpanSalePriceLabel>
          <Styled.SpanPrice>{salePriceText}</Styled.SpanPrice>
        </Styled.SpanSalePriceWrapper>
      )}
    </>
  );
};

LimitedPremiumDetailPriceText.displayName = "LimitedPremiumPriceText";
